var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8.78049,
    fill: "#575757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 16.1667C17.3333 16.65 17.725 17.0417 18.2083 17.0417C18.6915 17.0417 19.0833 16.65 19.0833 16.1667C19.0833 15.6835 18.6915 15.2917 18.2083 15.2917C17.725 15.2917 17.3333 15.6835 17.3333 16.1667Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 12.0833H17.3333C18.9832 12.0833 19.8082 12.0833 20.3207 12.5959C20.8333 13.1085 20.8333 13.9334 20.8333 15.5833V16.75C20.8333 18.3999 20.8333 19.2249 20.3207 19.7374C19.8082 20.25 18.9832 20.25 17.3333 20.25H13.8333C11.6334 20.25 10.5335 20.25 9.85004 19.5666C9.16663 18.8832 9.16663 17.7832 9.16663 15.5833V14.4167C9.16663 12.2168 9.16663 11.1168 9.85004 10.4334C10.5335 9.75 11.6334 9.75 13.8333 9.75H16.1666C16.7091 9.75 16.9804 9.75 17.2029 9.80963C17.8068 9.97145 18.2785 10.4432 18.4403 11.0471C18.5 11.2696 18.5 11.5408 18.5 12.0833",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsSuccess);
export default __webpack_public_path__ + "static/media/notifications_success.4ec56abd195a8942cf4c6e4d8f921cdc.svg";
export { ForwardRef as ReactComponent };